import * as React from 'react';
import moment from 'moment';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { Link } from 'react-router-dom';

const TYPE_VARIABLES_MAP = {
  draft: {
    text: 'Draft',
    textClass: 'text-info',
    actionText: 'Saved As Draft',
    editText: 'Continue Draft',
  },
  sent: {
    text: 'Sent',
    textClass: 'text-success',
    actionText: 'Sent',
    editText: 'Re-use',
  },
  scheduled: {
    text: 'Scheduled',
    textClass: 'text-primary',
    actionText: 'Scheduled For',
    editText: 'Cancel',
  },
};

type AnnouncementItemProps = {
  announcement: any;
  type: 'draft' | 'sent' | 'scheduled';
  deleteAnnouncement: (
    id: string,
  ) => (event: React.MouseEvent) => Promise<void>;
};

const onClick = (event: React.MouseEvent) => {
  const item = event.currentTarget.closest('.announcement-item');
  item.classList.toggle('preview');
};

const stopPropagation = (event: React.MouseEvent) => {
  event.stopPropagation();
};

const AnnouncementItem = (props: AnnouncementItemProps) => {
  const {
    announcement: { id, subject, dateSent, userName, body, delay, updatedAt },
    type,
    deleteAnnouncement,
  } = props;
  let time = type === 'draft' ? updatedAt : dateSent;
  if (type === 'scheduled' && delay) {
    ({ dateToSend: time } = delay);
  }

  const link = type === 'draft' ? `/${id}/edit` : `/new?reuse=${id}`;
  return (
    <div onClick={onClick} className="announcement-item">
      <div className="thumbnail-container"></div>
      <div className="details-container">
        <h4>
          {subject}
          <small className={TYPE_VARIABLES_MAP[type].textClass}>
            {' '}
            {TYPE_VARIABLES_MAP[type].text}
          </small>
        </h4>
        <p>
          <strong>{TYPE_VARIABLES_MAP[type].actionText}: </strong>
          {moment(time).format('MMM Do YYYY, HH:mm')} by <i>{userName}</i>
        </p>
        <FroalaEditorView model={body} />
      </div>
      <div className="action-container" onClick={stopPropagation}>
        {type === 'scheduled' ? (
          <button className="btn btn-danger" onClick={deleteAnnouncement(id)}>
            {TYPE_VARIABLES_MAP[type].editText}
          </button>
        ) : (
          <div className="btn-group">
            <Link to={link} type="button" className="btn btn-default">
              {TYPE_VARIABLES_MAP[type].editText}
            </Link>
            <button
              type="button"
              className="btn btn-default dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="caret"></span>
              <span className="sr-only">Toggle Dropdown</span>
            </button>
            <ul className="dropdown-menu">
              <li>
                <button onClick={deleteAnnouncement(id)} className="btn btn-sm">
                  Delete
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnnouncementItem;
